import { render, staticRenderFns } from "./T3Prize.vue?vue&type=template&id=e419f64c"
import script from "./T3Prize.vue?vue&type=script&lang=ts"
export * from "./T3Prize.vue?vue&type=script&lang=ts"
import style0 from "./T3Prize.vue?vue&type=style&index=0&id=e419f64c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports